import { APICfg } from 'services/api/api'
import { productSectionParse } from '../utils'
import { ProductSection } from '../types'
import { APIEventPackage } from './eventPackage'

type EventPackageSection = ProductSection<APIEventPackage>

type EventPackageSectionToAPI = EventPackageSection

const apiCfg: APICfg = {
  endpoint: 'eventpackagessections',
  parse: productSectionParse,
  write: async (req: EventPackageSection): Promise<EventPackageSectionToAPI> =>
    req,
}

export default apiCfg
